export enum ResizeDirection {
  INCREASE = 'increase',
  DECREASE = 'decrease'
}

export enum ResizeDimension {
  HEIGHT = 'height',
  WIDTH = 'width'
}

export enum ResizeMode {
  BOTH = 'both',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
  NONE = 'none'
}
